import * as S from "./style.styled";

const legendCallback = (chart, toggleDatasetVisibility, hiddenDatasets) => {
  const { data } = chart;

  return (
    <S.LegendWrap>
      {data.datasets.map((dataset, i) => (
        <S.LegendItem key={i} onClick={() => toggleDatasetVisibility(i)}>
          <S.LegendColorBox color={dataset.backgroundColor}>
            {!hiddenDatasets.includes(i) && (
              <S.CheckIcon
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="none"
                stroke="white"
              >
                <rect width="20" height="20" rx="2" fill={dataset?.colorText} />
                <path
                  d="M5 8.68778L9.32143 13.6154L16 6"
                  stroke="white"
                  strokeWidth="2"
                />
              </S.CheckIcon>
            )}
          </S.LegendColorBox>
          <S.LegendLabel>{dataset.label}</S.LegendLabel>
        </S.LegendItem>
      ))}
    </S.LegendWrap>
  );
};

export function LegendContainer({ datas, setHiddenDatasets, hiddenDatasets }) {
  const toggleDatasetVisibility = (index: number) => {
    setHiddenDatasets((prev) => {
      const newHiddenDatasets = [...prev];
      if (newHiddenDatasets.includes(index)) {
        newHiddenDatasets.splice(newHiddenDatasets.indexOf(index), 1);
      } else {
        newHiddenDatasets.push(index);
      }
      return newHiddenDatasets;
    });
  };

  return (
    <>
      <div id="legend-container">
        {legendCallback(
          { data: datas },
          toggleDatasetVisibility,
          hiddenDatasets
        )}
      </div>
    </>
  );
}
